/* eslint no-param-reassign: 0 */
import * as types from '../mutation-types';
import DisparoConfigAPI from '../../api/disparoConfig';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const state = {
  config: null,
  permittedUserIds: [],
  canAccessDisparo: false,
  uiFlags: {
    isFetching: false,
    isUpdating: false,
    isFetchingPermissions: false,
    isUpdatingPermissions: false,
  },
};

export const getters = {
  getConfig: $state => $state.config,
  getPermittedUserIds: $state => $state.permittedUserIds,
  getCanAccess: $state => $state.canAccessDisparo,
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.default.SET_DISPARO_CONFIG_UI_FLAG, { isFetching: true });
    try {
      const { data } = await DisparoConfigAPI.show();
      commit(types.default.SET_DISPARO_CONFIG, data.config);
    } catch (error) {
      commit(types.default.SET_DISPARO_CONFIG, null);
    } finally {
      commit(types.default.SET_DISPARO_CONFIG_UI_FLAG, { isFetching: false });
    }
  },
  save: async ({ commit }, payload) => {
    commit(types.default.SET_DISPARO_CONFIG_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await DisparoConfigAPI.save(payload);
      commit(types.default.SET_DISPARO_CONFIG, data.config);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.default.SET_DISPARO_CONFIG_UI_FLAG, { isUpdating: false });
    }
  },
  fetchPermissions: async ({ commit }) => {
    commit(types.default.SET_DISPARO_CONFIG_UI_FLAG, {
      isFetchingPermissions: true,
    });
    try {
      const { data } = await DisparoConfigAPI.getPermissions();
      commit(types.default.SET_DISPARO_PERMISSIONS, data.user_ids || []);
    } catch (error) {
      commit(types.default.SET_DISPARO_PERMISSIONS, []);
    } finally {
      commit(types.default.SET_DISPARO_CONFIG_UI_FLAG, {
        isFetchingPermissions: false,
      });
    }
  },
  fetchCanAccess: async ({ commit }) => {
    try {
      const { data } = await DisparoConfigAPI.canAccess();
      commit('SET_CAN_ACCESS', !!data.allowed);
    } catch (error) {
      commit('SET_CAN_ACCESS', false);
    }
  },
  updatePermissions: async ({ commit }, userIds) => {
    commit(types.default.SET_DISPARO_CONFIG_UI_FLAG, {
      isUpdatingPermissions: true,
    });
    try {
      const { data } = await DisparoConfigAPI.updatePermissions(userIds);
      commit(types.default.SET_DISPARO_PERMISSIONS, data.user_ids || []);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.default.SET_DISPARO_CONFIG_UI_FLAG, {
        isUpdatingPermissions: false,
      });
    }
  },
};

export const mutations = {
  [types.default.SET_DISPARO_CONFIG_UI_FLAG]($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
  [types.default.SET_DISPARO_CONFIG]($state, config) {
    $state.config = config;
  },
  [types.default.SET_DISPARO_PERMISSIONS]($state, ids) {
    $state.permittedUserIds = ids;
  },
  SET_CAN_ACCESS($state, allowed) {
    $state.canAccessDisparo = allowed;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
